import {useState} from "react";
import moment from "moment";
import { Card, Row, Col, Tag, Button, Space, Typography } from 'antd';
import ChargeAndDisputesDetails from "./ChargeAndDisputesDetails";
import Data from "../../../CustomText/data";
import { convertCentsIntoDollar, formatDate } from "../../../../helpers/genericHelper";


export default function InvoiceDetails({ invoice, charges, disputes }) {

  const [showCharges, setShowCharges] = useState(false);

  const getStatusColor = (status) => {
    switch (status) {
      case 'paid':
        return 'green';
      default:
        return 'default';
    }
  }

  return (
    <Card
      bordered={true}
      className="criclebox tablespace mb-16 card-cancel-subscription">
      <Row>
        <Col span={12}>
          <Space direction="vertical" style={{width: '100%'}}>
            <Row>
              <Col span="12">
                <Data title="Invoice ID" value={invoice?.id} />
                {
                  invoice?.id &&
                    <strong><a
                      href={"https://dashboard.stripe.com/invoices/" + invoice?.id}
                      title="Open in Stripe"
                      target="_blank"
                    >&nbsp;<small>open</small></a></strong>
                }
              </Col>
              <Col span="6">
                <Data title="Total" value={invoice?.total ? convertCentsIntoDollar(invoice?.total) : null} />
              </Col>
              <Col span="6">
                <Data title="Tax" value={invoice?.tax ? convertCentsIntoDollar(invoice?.tax) : null} />
              </Col>
            </Row>
            <Space >
              <Tag>
                <small>Created:</small> <strong>{moment.unix(invoice?.created).format('YYYY-MM-DD')}</strong>
              </Tag>
            { invoice?.status === 'paid' &&   
              <Tag>
                <small>Paid:</small> <strong>{formatDate(moment.unix(invoice?.paidDate).toDate(), true)}</strong>
              </Tag>}
              <Tag color={getStatusColor(invoice?.status)}>
                <small>Status:</small> <strong>{invoice?.status}</strong>
              </Tag>
            </Space>
          </Space>
        </Col>
        {!showCharges && <Button type="primary" ghost onClick={() => setShowCharges(true)}>
            Show Charges
        </Button>}
        </Row>
      <Row>
        <Col span={24}>
          {showCharges && <>
            {charges.map((charge) => (
              <ChargeAndDisputesDetails
                charge={charge}
                disputes={Object.values(disputes || {}).map(d => d[0]).filter(d => d.charge === charge.id)}
              />
            ))}
            {charges.length === 0 && <Typography.Text strong>- No charges found -</Typography.Text>}
          </>}
        </Col>
      </Row>
    </Card>
  )
}